import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Paragraph from "../typography/Paragraph"
import './CheckList.scss'

const CheckList = ({ className, title, children }) => (
    <div className={cx('check-list-container', className)}>
        {title && <Paragraph className='check-list-title'>{title}</Paragraph>}
        <ul className='check-list'>
            {children}
        </ul>
    </div>
)

CheckList.propTypes = {
}

export default CheckList



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/CheckList/CheckList.jsx